import React, { FunctionComponent } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';

import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import PrintIcon from '@mui/icons-material/Print';

import {
  Box,
  CircularProgress
} from '@mui/material';

import {
  Button,
  Typography
} from '../styled';
// import { Removal } from '../dialogs/Removal';

type Props = {
  sx?: object;
  label: React.ReactNode | string;
  id: string;
  secondary?: boolean;
  contained?: boolean;
  text?: boolean;
  fullwidth?: boolean;
  grayed_out?: boolean;
  disabled?: boolean;
  loading?: boolean;
  white?: boolean;
  itsme?: boolean;
  print?: boolean;
  path?: string;
  size?: "large" | "medium" | "small";
  onClick?: (e:React.MouseEvent, f?:boolean) => void;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  color?: "inherit" | "success" | "warning" | "error" | "info" | "primary" | "secondary";
};

export const WideButton: FunctionComponent<Props> = ({color, size, fullwidth, disabled, loading, itsme, print, label, onClick, path, sx, id, contained, text, secondary, startIcon, endIcon, grayed_out}) => {
  const theme = useTheme();
  // const navigate = useNavigate();

  return (<>
    <Box
      sx={{
        backgroundColor: (!!disabled ? 'lightgray' : 'white'),
        border: `1px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        borderRadius: 5,
        padding: 1,
        '&:hover': {
          backgroundColor: (!!disabled ? 'lightgray' : theme.palette.secondary.light)
        },
        ...(!!disabled ? {} : {cursor: 'pointer'}),
        whiteSpace: 'break-space',
        'p > p': {
          marginBottom: '0px !important',
          marginTop: 0
        },
        ...sx
      }}
      onClick={(e) => {if (!!onClick) onClick(e);}}
      onAuxClick={(e) => {if (!!onClick) onClick(e);}}
      onMouseDown={(e) => {if (!!onClick && e.button == 1) onClick(e);}}
    >
      <Box sx={{
        width: 'calc(100% - 70px)',
        minHeight: '60px',
        display: 'inline-block',
        paddingLeft: 1
      }}>
        <Typography html fuck_p_tags>{label}</Typography>
      </Box>
      <Box sx={{
        width: '60px',
        display: 'inline-block',
        float: 'left',
        marginRight: 1
      }}>
        {!!itsme && <React.Fragment>
          <svg color="#ff4612" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="Icon_icon__svg__1ABdY"><path d="M4.28 57.34C.91 53.97-.837 47.446.396 42.844l6.728-25.108c1.233-4.603 6.01-9.38 10.613-10.613L42.844.395C47.446-.838 53.97.91 57.34 4.28l18.38 18.38c3.37 3.362 5.116 9.893 3.894 14.495l-6.737 25.108c-1.233 4.603-6.01 9.38-10.613 10.613l-25.108 6.737C32.554 80.847 26.03 79.1 22.66 75.73L4.28 57.34z" fill="currentColor"></path><path d="M49.094 28.807c-2.389-.816-3.906-1.13-3.798-2.545.084-1.103.92-1.67 2.453-1.544 1.118.086 1.795.549 2.136 1.246a2.647 2.647 0 002.323 1.473c2.227.049 3.584-2.538 2.188-4.276-1.255-1.562-3.32-2.618-6.23-2.84-5.11-.393-8.33 1.892-8.63 5.782-.32 4.166 2.48 5.293 6.72 6.724 2.895.933 3.612 1.385 3.528 2.602-.09 1.18-1.125 1.765-2.697 1.652-1.31-.101-2.115-.62-2.494-1.398-.426-.882-1.38-1.37-2.354-1.39a2.617 2.617 0 00-1.947.786s-1.102 1.233-3.253 1.233c-1.563-.042-2.948-.883-2.948-3.072l.053-7.322a3.138 3.138 0 101.632-5.81 3.056 3.056 0 00-1.597.464l.004-2.689a1.717 1.717 0 00-1.715-1.726h-2.33a1.716 1.716 0 00-1.715 1.707l-.102 15.72c-.152 1.956-1.504 2.708-3.017 2.719-1.605 0-3.047-.84-3.047-3.072l.108-9.925a1.134 1.134 0 00-1.134-1.142h-3.487a1.134 1.134 0 00-1.133 1.125l-.11 11.327c-.04 4.721 3.68 6.845 8.803 6.845 2.144 0 3.615-.864 4.632-2.066 1.3 1.404 3.332 2.066 5.791 2.066 2.459 0 4.298-.322 6.124-1.358 1.27.747 2.89 1.215 4.852 1.365 5.306.408 8.535-1.985 8.853-6.122.277-3.69-2.495-5.17-6.462-6.54zM19.628 19.65a3.138 3.138 0 10-3.127-3.11 3.13 3.13 0 003.127 3.11zm36.84 23.117c-5.142 0-9.002 2.893-10.065 7.778-.29-4.576-3.209-7.32-7.511-7.32-3.002 0-4.965 1.348-6.118 3.156-1.31-2.03-3.502-3.156-6.235-3.156-2.536 0-10.544-.308-10.544 9.98v7.489a2.81 2.81 0 105.618 0v-8.226c0-2.386 1.347-4 3.579-4 2.04 0 3.23 1.422 3.23 3.97v8.271a2.81 2.81 0 005.62 0v-8.933c.22-2 1.462-3.309 3.462-3.309 2.155 0 3.309 1.423 3.309 3.97v8.273a2.81 2.81 0 105.617 0v-4.398c1.102 4.794 4.962 7.666 10.193 7.666 2.459 0 4.792-.752 6.488-1.985.06-.042.115-.084.172-.126.057-.041.133-.092.194-.143 0 0 0-.018.014-.024.092-.075.191-.148.28-.22 1.645-1.505.699-4.268-1.511-4.56a2.646 2.646 0 00-2.52 1.103c-.643.838-1.752 1.31-3.27 1.31-2.602 0-4.139-1.616-4.258-4.14h12.163a1.833 1.833 0 001.832-1.832v-.454c0-6.354-3.863-10.14-9.738-10.14zm-4.258 8.6c.157-2.602 1.764-4.1 4.219-4.1 2.602 0 3.864 1.617 3.983 4.1H52.21z" fill="#fff"></path></svg>
        </React.Fragment>}
        {!loading && !itsme && !print && <React.Fragment>
          <AssignmentIndIcon sx={{height: '60px', width: 'auto'}} />
        </React.Fragment>}
        {!loading && !itsme && !!print && <React.Fragment>
          <PrintIcon sx={{height: '60px', width: 'auto'}} />
        </React.Fragment>}
        {!!loading && !itsme && <React.Fragment>
          <CircularProgress sx={{width: 'auto', marginTop: 1.25, marginLeft: 1.25}} />
        </React.Fragment>}
      </Box>
    </Box>
  </>);
}